import React from "react";
import { ReactSVG } from "react-svg";
import { getPanesIcon } from "../../../../utils/images";
import "./ConversationPane.scss";

const ConversationPane = ({ shipment }) => {
  return (
    <div className="ConversationPane pane">
      <div className="pane__header">
        <ReactSVG src={getPanesIcon('conversations')} />
        <div className="pane__title">Conversations</div>
      </div>
      <div className="pane__wrapper">
      </div>
    </div>
  )
}

export default ConversationPane;
